const CircleWithWarningIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={100} height={100} {...props}>
    <g data-name="Certificate loschen" transform="translate(-6013 -6700)">
      <circle
        cx={50}
        cy={50}
        r={50}
        fill="#e8fcff"
        data-name="Ellipse 106"
        transform="translate(6013 6700)"
      />
      <path
        fill="#00c4de"
        d="M6036.276 6775h53.45l-26.724-50Zm29.587-7.692h-5.726v-5.77h5.727Zm0-9.615h-5.726v-11.539h5.727Z"
        data-name="Icon ionic-md-warning"
      />
    </g>
  </svg>
);

export default CircleWithWarningIcon;
